const API = process.env.REACT_APP_API_URL;

const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

// ================= GET Jobs by emplacementId =================

export const getJobsByEmplacement = async (token, id) => {
  const res = await fetch(`${API}/JobManagement/GetJobs/${id}`, {
    method: "GET",
    headers: headers(token),
  });

  if (!res.ok) throw new Error("Error ALL articles");
  return res.json();
};

//===========================Save jobs Selections===============
export const saveJobsSelection = async (token, emplacementId, selectedJobs) => {
  const payload = {
    noEmplacement: emplacementId,
    jobIds: selectedJobs,
  };

  const response = await fetch(`${API}/JobManagement/SaveJobs`, {
    method: "POST",
    headers: headers(token),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Error saving jobs");
  }

  return await response.json();
};

//===========================create a jobs===============
export const createJob = async (token, payload) => {
  const res = await fetch(`${API}/JobManagement/CreateJob`, {
    method: "POST",
    headers: headers(token),
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const error = await res.json();
    throw error;
  }

  return res.json();
};

export const updateJob = async (token, id, payload) => {
  const res = await fetch(`${API}/JobManagement/UpdateJob/${id}`, {
    method: "PUT",
    headers: headers(token),
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const error = await res.json();
    throw error;
  }

  return res.json();
};
